var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOnline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 51,
    viewBox: "0 0 51 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 20.75C12 17.5744 14.5744 15 17.75 15H32.75C35.9256 15 38.5 17.5744 38.5 20.75V30.75C38.5 33.9256 35.9256 36.5 32.75 36.5H17.75C14.5744 36.5 12 33.9256 12 30.75V20.75ZM17.75 16.5C15.4028 16.5 13.5 18.4028 13.5 20.75V23.2178H13.75H37L37 20.75C37 18.4028 35.0972 16.5 32.75 16.5H17.75ZM13.5 30.75V24.7178H13.75H37V30.75C37 33.0972 35.0972 35 32.75 35H17.75C15.4028 35 13.5 33.0972 13.5 30.75ZM18.75 30.25C17.9216 30.25 17.25 30.9216 17.25 31.75C17.25 32.5784 17.9216 33.25 18.75 33.25H22.5C23.3284 33.25 24 32.5784 24 31.75C24 30.9216 23.3284 30.25 22.5 30.25H18.75ZM34.75 19.75C34.75 20.8546 33.8546 21.75 32.75 21.75C32.3857 21.75 32.0442 21.6526 31.75 21.4824C31.4558 21.6526 31.1143 21.75 30.75 21.75C29.6454 21.75 28.75 20.8546 28.75 19.75C28.75 18.6454 29.6454 17.75 30.75 17.75C31.1143 17.75 31.4558 17.8474 31.75 18.0176C32.0442 17.8474 32.3857 17.75 32.75 17.75C33.8546 17.75 34.75 18.6454 34.75 19.75Z",
    fill: "#CA1211"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnline);
export default __webpack_public_path__ + "static/media/online.c0c822a2c2b20dc34a3916b1e3571706.svg";
export { ForwardRef as ReactComponent };